var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuPerformance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2408_2749",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 17,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.722656,
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2408_2749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.05599 14C3.68932 14 3.37532 13.8696 3.11399 13.6087C2.8531 13.3473 2.72266 13.0333 2.72266 12.6667V3.33333C2.72266 2.96667 2.8531 2.65267 3.11399 2.39133C3.37532 2.13044 3.68932 2 4.05599 2H6.72266C7.08932 2 7.40332 2.13044 7.66466 2.39133C7.92555 2.65267 8.05599 2.96667 8.05599 3.33333V12.6667C8.05599 13.0333 7.92555 13.3473 7.66466 13.6087C7.40332 13.8696 7.08932 14 6.72266 14H4.05599ZM10.7227 6.66667C10.356 6.66667 10.0422 6.536 9.78132 6.27467C9.51999 6.01378 9.38932 5.7 9.38932 5.33333V3.33333C9.38932 2.96667 9.51999 2.65267 9.78132 2.39133C10.0422 2.13044 10.356 2 10.7227 2H13.3893C13.756 2 14.07 2.13044 14.3313 2.39133C14.5922 2.65267 14.7227 2.96667 14.7227 3.33333V5.33333C14.7227 5.7 14.5922 6.01378 14.3313 6.27467C14.07 6.536 13.756 6.66667 13.3893 6.66667H10.7227ZM10.7227 14C10.356 14 10.0422 13.8696 9.78132 13.6087C9.51999 13.3473 9.38932 13.0333 9.38932 12.6667V9.33333C9.38932 8.96667 9.51999 8.65267 9.78132 8.39133C10.0422 8.13044 10.356 8 10.7227 8H13.3893C13.756 8 14.07 8.13044 14.3313 8.39133C14.5922 8.65267 14.7227 8.96667 14.7227 9.33333V12.6667C14.7227 13.0333 14.5922 13.3473 14.3313 13.6087C14.07 13.8696 13.756 14 13.3893 14H10.7227Z",
    fill: "#141320"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPerformance);
export default __webpack_public_path__ + "static/media/menu-performance.0e3f386e340b0c0e030b401f51b3d4d6.svg";
export { ForwardRef as ReactComponent };